import { pipe } from 'fp-ts/lib/function';
import { map, toUndefined } from 'fp-ts/lib/Option';
import { FC, useMemo } from 'react';
import { useLinks } from '../../hooks/useLinks';
import { useLocale } from '~/stores/locale';
import * as B from 'fp-ts/boolean';
import { constants } from '@oresundsbron/validators';
import { lookup } from 'fp-ts/lib/Record';
import { DefaultLink } from './DefaultLink';
import { LinkProps } from './types';

const storebeltPrivacyPolicy = {
  sv: 'https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/',
  da: 'https://storebaelt.dk/privatlivspolitik-for-storebaelt-dk/',
  en: 'https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/',
};

type PrivacyPolicyLinkProps = Omit<LinkProps, 'href'> & {
  type?: string;
};

export const PrivacyPolicyLink: FC<PrivacyPolicyLinkProps> = ({
  type,
  ...rest
}) => {
  const { findLinkByCodeRef } = useLinks();
  const { locale } = useLocale();

  const href = useMemo(
    () =>
      pipe(
        type === constants.Storebelt,
        B.match(
          () =>
            pipe(
              findLinkByCodeRef('privacy_policy'),
              map((l) => `/${l.locale}${l.path}`),
              toUndefined
            ),
          () => pipe(storebeltPrivacyPolicy, lookup(locale), toUndefined)
        )
      ),
    [findLinkByCodeRef, locale, type]
  );

  return <>{href && <DefaultLink {...rest} href={href} target="_blank" />}</>;
};
